import React from 'react';
import classnames from 'classnames';
import { getLabel } from 'utils/getLabel';
import { map, get } from 'lodash';

// local dependencies
import { Icon } from 'modules/icon-bank';
import { withNetworkState } from 'ui/hoc/withNetworkState';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsSavingsAndBalance as MemberDetailSavingsAndBalance } from 'ui/views/widgets/memberDetailsSavingsAndBalance';
 *
 * // render
 * <MemberDetailSavingsAndBalance propName='propValue'/>
 */

// success view
const memberDetailsSavingsWidgetSuccess = ( props ) => {

    // widget class name
    const widgetClassName = classnames( 'ui-member-detail-section', props.className );

    return(
        <div className={ widgetClassName }>
            {
                map( props.cards, ( card ) => {

                    const className = classnames( 'ui-member-detail-section__card',
                        `ui-member-detail-section__card__${card.name}`
                    );

                    return (
                        <div key={ card.name } onClick={ () => props.onActionClick( { value: card } ) } className= { className } >
                            <div className="ui-member-detail-section__card__info">
                                
                                {/* card name */}
                                <p className="ui-member-detail-section__card__info__title">
                                    {getLabel( card.title )}
                                </p>

                                {/* card amount */}
                                <p className="ui-member-detail-section__card__info__amount">
                                    ${ get( props, `balanceAndSavings.${[ card.name ]}`, [] ) }
                                </p>
                            </div>
                            
                            <div className="ui-member-detail-section__card__icon" >
                                {/* icon */}
                                <Icon
                                    name={ card.name }
                                />
                            </div>
                        </div>
                    );
                } )
            }
        </div>
    );
};

// set display name
memberDetailsSavingsWidgetSuccess.displayName = 'memberDetailsSavingsWidget';

// set default props
memberDetailsSavingsWidgetSuccess.defaultProps = {
    title: null,
    state: null,
    cards: [],
};

// prop types
memberDetailsSavingsWidgetSuccess.propTypes = {};

/**
 * @type {object}
 * @desc A React presentation/dumb view component preloader.
 * @example
 * import { memberDetailsSavingsWidgetPreloader as MemberDetailsSavingsWidgetPreloader } from 'ui/views/widgets/memberDetailsSavingsWidget';
 *
 * // render
 * <memberDetailsSavingsWidgetPreloader propName='propValue'/>
 */
const memberDetailsSavingsWidgetPreloader = ( ) => {
    return (
        <div className='ui-member-details-header-widget-preloader__savings'>
            <div className='ui-member-details-header-widget-preloader__savings__name'>
            </div>
            <div className='ui-member-details-header-widget-preloader__savings__details'>
                <div className='ui-member-details-header-widget-preloader__savings__details__specific'>
                    <p className='ui-member-details-header-widget-preloader__savings__details__specific__title__preloader'></p>
                </div>
                <div className='ui-member-details-header-widget-preloader__savings__details__specific'>
                    <div className='ui-member-details-header-widget-preloader__savings__details__specific__icon__preloader'></div>
                </div>
            </div>
        </div>
    );
};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsSavingsWidget as MemberDetailsSavingsWidget } from 'ui/views/widgets/memberDetailsSavingsWidget';
 *
 * // render
 * <memberDetailsSavingsWidget propName='propValue'/>
 */
export const memberDetailsSavingsWidget = withNetworkState( memberDetailsSavingsWidgetPreloader, memberDetailsSavingsWidgetSuccess );
